<template>
    <va-create-layout>
        <SAFETReimbursementEvent-form
            :title="title"
            :item="item"
        ></SAFETReimbursementEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
